module.exports = __webpack_public_path__ + "img/qyshop.cebf45d9.png";